import { Typography, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import ForgotPassword from "../../components/app/dialogs/forgotPassword/forgotPassword.jsx";
import Form from "../../components/app/forms/login/form.jsx";
import LanguageSelect from "../../components/app/languageSelect/languageSelect.jsx";
import Logo from "../../components/custom/general/logo/logo.jsx";

import useLogin from "../../hooks/login/useLogin";
import './login.css'

import useUserAction from "../../hooks/user/useUserAction";
import useUserData from "../../hooks/user/useUserData";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";

const Login = () => {
	const { t } = useTranslation(PAGE_LOGIN)
	const { checkAPIConnectivity } = useUserAction()
	const { loading, isLoggedIn } = useUserData()
	const { formik } = useLogin()
	const [openForgotPass, setOpenForgotPass] = useState(false)
	const theme = useTheme()
	useEffect(() => {
		if (!isLoggedIn) checkAPIConnectivity()
	}, [checkAPIConnectivity, isLoggedIn])
	
	return (
		<Box
			className={"login"}
		>
			<Box className={'login-right'} sx={{ backgroundColor: 'primary' }}>
				<Box mt={1} mb={1} sx={{ position: 'absolute', top: 0, right: '60px' }}>
					<LanguageSelect color={'#000000'}/>
				</Box>
				<Box>
					<Logo
						style={{
							maxHeight: '250px',
							height: 'auto',
							// backgroundColor: theme.palette.primary.darker,
							width: 'auto'
						}}
					/>
				</Box>
				<Box pt={2}>
					<Typography
						variant="h1"
						color={'primary'}
						sx={{
							textShadow: '0 13.36px 8.896px #c4b59d,0 -2px 1px #fff',
							letterSpacing: 1.6,
							textAlign: 'center'
						}}
					>
						{t("Connection")}
					</Typography>
				</Box>
				<Form
					formik={formik}
					loading={loading}
				/>
				<Box pt={2}>
					<Typography
						component={Button}
						onClick={() => setOpenForgotPass(true)}
						variant="body1"
						color={'secondary'}
					>
						{t("Forgot password? Click here.")}
					</Typography>
				</Box>
			</Box>
			<ForgotPassword
				open={openForgotPass}
				handleDialog={(newValue) => setOpenForgotPass(newValue)}
			/>
		</Box>
	)
}

export default Login